// Angular modules
import { Component }           from '@angular/core';
import { EventEmitter }        from '@angular/core';
import { Input }               from '@angular/core';
import { OnInit }              from '@angular/core';
import { Output }              from '@angular/core';
import { AbstractControl }     from '@angular/forms';
import { FormControl }         from '@angular/forms';
import { FormGroup }           from '@angular/forms';

// Models
import { Filter }              from '../../../../models/page.model';
import { FilterSelectOptions } from '../filter-select-options.model';

// Components
import { FilterComponent }     from '../filter.component';

@Component({
  selector    : 'app-select-field',
  templateUrl : './select-field.component.html',
  styleUrls   : ['./select-field.component.scss']
})
export class SelectFieldComponent implements OnInit, FilterComponent
{
  selectForm : FormGroup;

  @Input() data : FilterSelectOptions;

  @Output() dispatchFilterValue : EventEmitter<Filter> = new EventEmitter<Filter>();

  constructor() {}

  ngOnInit()
  {
    this.selectForm = new FormGroup({
      select : new FormControl('')
    });

    this.data.list.sort((a, b) => a.key.toLowerCase().localeCompare(b.key.toLowerCase()));
  }

  get select() : AbstractControl
  {
    return this.selectForm.get('select');
  }

  onSelectionChange() : void
  {
    const filter: Filter = {};
    filter.value         = this.select.value.key;
    filter.label         = this.select.value.value;
    filter.criteriaKey   = this.data.criteriaKey;
    filter.criteriaLabel = this.data.criteriaLabel;
    this.dispatchFilterValue.emit(filter);
    this.selectForm.reset();
  }
}
